import tools from './tools';

// Easymde component
export default function () {
    let root, textarea, instance;
    let instantiated = false;

    return {
        get value() {
            return instance ? instance.value() : textarea.value;
        },

        set value(value) {
            if (instance) {
                instance.value(value);

                if (root._x_model) {
                    root._x_model.set(value);
                }
            } else {
                textarea.value = value;

                if (root._x_model) {
                    root._x_model.set(value);
                }
            }
        },

        instance() {
            return instance;
        },

        init() {
            root = this.$root;
            root.setAttribute('x-ignore', '');

            textarea = this.$refs.textarea;

            if (this.isInModal) {
                this.instantiate();
            }
        },

        destroy() {
            if (!instance) return;

            instance.toTextArea();
            instance.cleanup();
            instance = null;
        },

        instantiate() {
            if (instantiated) return;
            instantiated = true;

            if (root._x_model) {
                const xModelWatcher = (value) => {
                    if (this.value !== value) {
                        this.value = value;
                    }
                };

                this.$watch(tools.getXModelValue(root), xModelWatcher);
                xModelWatcher(root._x_model.get());
            }

            const helpModal = {
                name: 'help',
                action() {
                    abmodal({
                        title: __('Markdown Guide'),
                        message: document.getElementById('easymde_help_modal').innerHTML,
                        backdrop: true,
                        closeButton: true,
                        onEscape: true,
                        buttons: {
                            close: {
                                label: __('Close'),
                            },
                        },
                    });
                },
                className: 'fas fa-circle-info',
                title: 'Help',
            };

            instance = new EasyMDE({
                element: textarea,
                maxHeight: root.getAttribute('height'),
                placeholder: root.getAttribute('placeholder'),
                autoDownloadFontAwesome: false,
                forceSync: true,
                status: false,
                spellChecker: false,
                inputStyle: 'contenteditable',
                toolbar: [
                    'heading',
                    'bold',
                    'italic',
                    'strikethrough',
                    '|',
                    'unordered-list',
                    'ordered-list',
                    'quote',
                    '|',
                    'link',
                    'image',
                    '|',
                    'preview',
                    '|',
                    helpModal,
                ],
            });

            const container = textarea.nextElementSibling;
            const name = textarea.name;

            container.setAttribute('error-for', name);
            document.querySelector(`label[for="${name}"]`)?.addEventListener('click', () => instance.codemirror.focus());

            let focused = false;
            let changed = false;

            instance.codemirror.on('focus', () => {
                focused = true;
                container.classList.add('focused');
            });

            instance.codemirror.on('change', () => {
                if (!focused) return;
                changed = true;

                if (root._x_model) {
                    root._x_model.set(instance.value());
                }

                this.$nextTick(() => {
                    root.dispatchEvent(new Event('input'));
                    Helper.dispatchCustomEvent('revalidate', { attribute: name });
                });
            });

            instance.codemirror.on('blur', () => {
                focused = false;
                container.classList.remove('focused');

                if (changed) {
                    changed = false;
                    root.dispatchEvent(new Event('change'));
                }
            });
        },

        focus() {
            if (!instance) return;

            instance.codemirror.focus();
        },
    };
}
